
export interface SweepAlias {
  [sid: string]: string;
}

const robinsonHall: SweepAlias = {
  "5a9bbf0002ff4ee994fe30139b609e4b" : "Entrance",
  "2cbbeb26d3cc489580052b13e1d3cfa1" : "Clothes",
  "b0d35f4869374a179c26eccbb8cadbdb" : "Frozen foods & Dairy",
  "f235db93748b4e9c9acfd4665a822e9f" : "Technology",
  "b0542449f58044afa18cfdbaf8d9e4c1" : "Exit",
  "6747b281ff554c01aeb00c8deb262437" : "Pharmacy",
  "86a53e633806457489730357c91e7411" : "Cosmetics",
  "56a9878236ef4d8da5554abeaef612b9" : "Sports",
  "ff7874670070447bad0b2cf78466ab25" : "outdoors",





};

const scu: SweepAlias = {
  "6d80bf2d4e71453aa0134fc61c2d8102": "Entrance",
  "ff56dea1f04c4ab08d2121d805cf9be2": "Sports Performance Center",
  "857ceb1a450d46099b6b9c66f81bd644": "Sobrato Gymnasium",
  "8ddd9373572b4ae7a6c7063a9dacdc3b": "Rambis Family Gymnasium",
  "cadbfa305b77449c8a5907fc2b9d1d0e": "Stevens Academic Center",
  "6c67c4e49ee440ad9895872922a12a32": "Sports Medicine Center",
}

export const sweepAliases: any = {
  "4McHn6Eg4Z9": robinsonHall,
  "JYz9SNonEqa": scu,
}
